import { _ as _defineProperty } from '../../defineProperty-6f298737.js';
import classNames from 'classnames';
import React__default from 'react';
import { getPrefixCls } from '../../utils/getPrefix.js';
import { IconColorPro } from '../IconColor/IconColorPro.js';
import '../../extends-30811c5e.js';
import '../../objectWithoutProperties-dd908bcc.js';

var prefixCls = getPrefixCls('pro');
var Pro = function Pro(_ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'm' : _ref$size,
    _ref$dataTestid = _ref.dataTestid,
    dataTestid = _ref$dataTestid === void 0 ? 'pro' : _ref$dataTestid;
  return /*#__PURE__*/React__default.createElement(IconColorPro, {
    "sl-test-data": dataTestid,
    className: classNames(prefixCls, className, _defineProperty({}, "".concat(prefixCls, "-").concat(size), size))
  });
};

export { Pro };
